export const GET_APP_PARAMETERS_LIST="GET_APP_PARAMETERS_LIST";
export const APP_PARAMETERS_MESSAGE="APP_PARAMETERS_MESSAGE";
export const APP_PARAMETERS_LIST="APP_PARAMETERS_LIST";
export const SHOW_LOADING="SHOW_LOADING";
export const HIDE_LOADING="HIDE_LOADING";
export const DELETE_APP_PAREMETER="DELETE_APP_PAREMETER";
export const UPDATE_APP_PARAMETER="UPDATE_APP_PARAMETER";
export const ADD_APP_PARAMETER="ADD_APP_PARAMETER";
export const APP_PARAMETER_REGISTER_SUCCESS="APP_PARAMETER_REGISTER_SUCCESS";